export const changeSiblingPositionSynchronously = (projectList, movedProject, newIndex) => {

    const item = movedProject;
    const itemArray = projectList;

    if (projectList.length === 1) {
        return projectList;
    }

    const startingPosition = item.siblingOrder;
    const targetPosition = newIndex;

    if (targetPosition !== null && targetPosition !== undefined) {
        if (startingPosition - targetPosition < 0) {
            for (let i = 0; i < itemArray.length; i++) {
                const other = itemArray[i];
                if (other.id === movedProject.id) {
                    other.siblingOrder = newIndex;
                }
                if (other.siblingOrder <= targetPosition && other.siblingOrder >= startingPosition) {
                    other.siblingOrder--;
                }
            }
        } else {
            for (let i = 0; i < itemArray.length; i++) {
                const other = itemArray[i];
                if (other.id === movedProject.id) {
                    other.siblingOrder = newIndex;
                }
                if (other.siblingOrder >= targetPosition && other.siblingOrder <= startingPosition) {
                    other.siblingOrder++;
                }
            }
        }
    } else {
        for (let i = 0; i < itemArray.length; i++) {
            const other = itemArray[i];
            if (other.id === movedProject.id) continue;
        }
    }

    item.siblingOrder = newIndex; 

    let order = 0;

    itemArray
        .filter(i => i.siblingOrder !== null)
        .sort((a, b) => a.siblingOrder - b.siblingOrder)
        .forEach(s => {
            console.log(s.title + " " + s.siblingOrder);
            s.siblingOrder = order++;
        });

    return itemArray;
}
